module.exports = __webpack_public_path__ + "static/Chat_port_desk-00ab473db3702aa82487a37036cd31ba.mp4";